import { connect } from 'react-redux';
import { withLastLocation } from 'react-router-dom-last-location';
import NavigationStackBar from './navigation_stack_bar';
import withPGTranslation from '../../config/withPGTranslation';

import { getRouteSettings } from '../../config/util';

const mapStateToProps = ({
  application
}, ownProps) => {
  const { currentPath: { routeKey } } = ownProps;
  return ({
    ...application,
    routeSettings: getRouteSettings({ routeKey })
  });
};

export default connect(
  mapStateToProps
)(withLastLocation(withPGTranslation(NavigationStackBar)));
